import { Button, Flex, Modal, Text } from "@mantine/core";

import { Loader } from "../../components/Loader.tsx";
import { DocumentInfo } from "./DocumentInfo/DocumentInfo.tsx";

interface ProcessingModalProps {
  opened: boolean;
  onClose: () => void;
  documentType?: string;
  companyName?: string;
  fileName?: string;
}

const ProcessingModal = ({
  opened,
  onClose,
  documentType,
  companyName,
  fileName,
}: ProcessingModalProps) => {
  return (
    <Modal opened={opened} size="md" onClose={onClose}>
      <Flex direction="column" gap={20}>
        <Flex direction="column" align="center" gap={20}>
          <Loader />

          <Text size="xl" align="center">
            Document Processing in Progress
          </Text>

          <Text size="md" align="center">
            Your document is currently being processed. This may take a few
            minutes. Please check back shortly for the results.
          </Text>

          {(documentType || companyName || fileName) && (
            <DocumentInfo>
              {fileName && (
                <Text size="sm">
                  <strong>File:</strong> {fileName}
                </Text>
              )}
              {documentType && (
                <Text size="sm">
                  <strong>Document Type:</strong> {documentType}
                </Text>
              )}
              {companyName && (
                <Text size="sm">
                  <strong>Company:</strong> {companyName}
                </Text>
              )}
            </DocumentInfo>
          )}

          <Text size="sm" align="center" color="dimmed" italic>
            The extracted data and forgery detection results will be available
            once processing is complete.
          </Text>
        </Flex>
        <Flex gap={20} justify="end">
          <Button variant="filledBlue" uppercase onClick={onClose}>
            OK
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ProcessingModal;
